import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderTextField } from '../../../../Forms/fieldRenderers'
import { EntityAutocomplete, CerealVariedadDropdown } from '../../../../Forms/SharedComponents/containers'

export default function CamposTransferencia (props) {
  return (
    <Row style={{ padding: '8px' }}>
      <Col md={6}>
        <EntityAutocomplete
          name='exportadorOrigen'
          label='Exportador origen'
          entity='exportador'
          placeholder='Exportador - 19999999991'
        />
      </Col>
      <Col md={6}>
        <EntityAutocomplete
          name='exportadorDestino'
          label='Exportador destino'
          entity='exportador'
          placeholder='Exportador - 19999999991'
        />
      </Col>
      <Col md={7}>
        <CerealVariedadDropdown cerealInicial={props.cerealInicial} />
      </Col>
      <Col md={5}>
        <Field
          name='cantidad'
          label='Cantidad (Kg.)'
          component={renderTextField}
        />
      </Col>
    </Row>
  )
}
